import { checkboxClasses } from "@mui/material";
const MuiCheckbox = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.border.prominent,
                '&:hover': {
                    backgroundColor: theme.palette.background.hover,
                    borderRadius: '4px',
                    [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
                        color: theme.palette.text.secondary
                    }
                },
                [`&.${checkboxClasses.disabled}`]: {
                    color: theme.palette.border.subtle
                }
            })
    }
};
export { MuiCheckbox };

//# sourceMappingURL=checkbox-overrides.js.map